module.exports = __webpack_public_path__ + "static/media/yam.e20b7983.png";